import _ from 'lodash';

export class Enum {
  constructor(properties) {
    _.forEach(properties, (val, key) => {
      this[key] = val;
      this[val] = key;
    });
  }
}
